export const NSFW = () => {
  return (
      <div className='recruiting-email'>
        <div className="recruiting-email__title">Subject: NSFW</div>
        <div className="recruiting-email__body">
          <p>
            <span className="redact">Hi William,</span>
          </p>
          <p>
            I want
            <span className="redact">ed to let you know that we have</span>
             a <span className="redact">position for a Sr. Software Engineer with a client company. The company is a leading blockchain venture capital</span> firm
          </p>
          <p>
            <span className="redact">You would be working in the company's office in San Diego (Del Mar area). The company will relocation</span> assistance
            <span className="redact">You could work from home up to 3x/week.</span>
          </p>
          <p>
            <span className="redact">You would ideally be spending about</span> 50%
            <span className="redact">of your time</span> on front/back
            <span className="redact">end engineering,</span> but
            <span className="redact">depending on your preference</span> it could be
            <span className="redact">anywhere from 80% frontend to</span> 100% back
            <span className="redact">end.</span>
            <span className="redact">The tech stack includes Go, JavaScript, and React.</span>
          </p>
          <p>
            <span className="redact">The company will pay a salary up to $240k, plus carry (similar to equity), plus up to 50% of salary in yearly bonuses.</span>
          </p>
          <p>
            <span className="redact">I'm guessing you may not be actively seeking a new job right now, but whatever the case may be, </span> pleas
            <span className="redact">e let me know if you or anyone you know may be open to hear</span>ing more and exploring
            <span className="redact">this opportunity.</span>
          </p>
          <p>
            <span className="redact">We work with many high growth companies, so if this</span> particular
            <span className="redact">opportunity is not a match but you would like to know what other </span> opportunities
            <span className="redact">we could connect you with,</span> please
            <span className="redact">let me know.</span>
          </p>
          <p>
            <span className="redact">I look forward to hearing from you.</span>
          </p>
          <p>
            <span className="redact">Redacted Name</span>
          </p>
        </div>
      </div>
  )
}

export default NSFW
